"use strict";

import DictionaryApi from "@/api/dictionary.js";
import { parseResponse, handleError } from "@/_helpers/utils.js";
import axios from "axios";
import qs from "qs";
import VacancyApi from "@/api/vacancy";

const actions = {
  async fetch({ commit, rootState, dispatch }) {
    commit("dictionary/fetch", null, { root: true });
    const statusesParams = {};

    if (
      rootState.responses.filters.vacancy &&
      rootState.responses.filters.vacancy.id !== "all"
    ) {
      statusesParams.vacancy_id = rootState.responses.filters.vacancy.id;
    }

    const statuses = await dispatch("fetchStatuses");
    let filter = [];
    filter['active'] = true;
    return Promise.all([
      statuses,
      DictionaryApi.fetchStages(),
      VacancyApi.fetchList({
        filter
      })
    ])
      .then(data => {
        commit(
          "dictionary/fetchSuccess",
          {
            responseStatuses: data[0].filter(s => !s.is_hidden),
            responseStages: data[1],
            vacancies: data[2].data
          },
          { root: true }
        );
      })
      .catch(err => {
        dispatch("global/setError", err, { root: true });
        commit("dictionary/fetchFailure", err, { root: true });
      });
  },

  async fetchStagesAndStatuses({ commit, rootState, dispatch }, model) {
    commit("dictionary/fetch", null, { root: true });
    let statusesParams = {};

    if (model) {
      statusesParams = model;
    }

    if (
      rootState.responses.filters.vacancy &&
      rootState.responses.filters.vacancy.id !== "all"
    ) {
      statusesParams.vacancy_id = rootState.responses.filters.vacancy.id;
    }

    const statuses = await dispatch("fetchStatuses");
    const stages = await DictionaryApi.fetchStages();

    return Promise.all([statuses, stages])
      .then(data => {
        const result = {
          responseStatuses: data[0].filter(s => !s.is_hidden),
          responseStages: data[1]
        };

        commit("dictionary/fetchSuccess", result, { root: true });
        return data;
      })
      .catch(err => {
        dispatch("global/setError", err, { root: true });
        commit("dictionary/fetchFailure", err, { root: true });
      });
  },

  async fetchStatuses(context, params) {
    return new Promise((resolve, reject) => {
      axios
        .get("/1.0/spec-private/sportmaster/response-statuses", {
          params,
          paramsSerializer: params => {
            return qs.stringify(params);
          },
          showProgressBar: false
        })
        .then(response => resolve(parseResponse(response).data))
        .catch(err => reject(handleError(err)));
    });
  }
};

export default {
  namespaced: true,
  actions
};
